import React from 'react';
import { XCircle } from 'lucide-react';
import { FadeIn } from './ui/FadeIn';
const failures = ['Aplicar masivamente en LinkedIn sin optimizar tu perfil para los filtros automáticos (ATS) internacionales.', 'Competir solamente por ser "el más barato", lo que te posiciona como mano de obra desechable en lugar de un socio estratégico.', 'Usar un CV biográfico que cuenta tu historia en lugar de un CV "Remote-First" que muestra tus resultados cuantificables.', 'Esperar a tener un "inglés perfecto" cuando lo que el mercado demanda es comunicación funcional y asíncrona.'];
export function FailedAttempts() {
  return <section className="py-24 px-4 bg-navy-900" data-id="element-1">
      <div className="max-w-4xl mx-auto" data-id="element-2">
        <FadeIn data-id="element-3">
          <h2 className="text-3xl md:text-4xl font-bold text-center mb-16" data-id="element-4">
            Por qué lo que has intentado{' '}
            <span className="text-red-400" data-id="element-5">no funciona</span>
          </h2>
        </FadeIn>

        <div className="grid gap-6" data-id="element-6">
          {failures.map((failure, index) => <FadeIn key={index} delay={index * 0.1} direction="left" data-id="element-7">
              <div className="flex items-start gap-4 p-6 rounded-xl bg-navy-800 border border-navy-600 hover:border-red-500/20 transition-colors" data-id="element-8">
                <XCircle className="w-6 h-6 text-red-400 shrink-0 mt-1" data-id="element-9" />
                <p className="text-lg text-slate-300" data-id="element-10">{failure}</p>
              </div>
            </FadeIn>)}
        </div>
      </div>
    </section>;
}